module.exports = __webpack_public_path__ + "img/filter.dfc0ebb8.svg";